"use client";
import Image from "@/components/Image/Image.component";
import TextOverlay from "@/components/TextOverlay/TextOverlay.component";
import { Typography } from "@/components/Typography/Typography.component";
import { useBreakpoints } from "@/hooks/useBreakpoints/useBreakpoints";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { CSSTransition } from "react-transition-group";
import { CapabilityServiceCardPropsModel } from "./CapabilityServiceCard.model";

const CapabilityServiceCard = ({
  title,
  description,
}: CapabilityServiceCardPropsModel) => {
  const [showActiveOverlay, setShowActiveOverlay] = useState<boolean>(false);
  const showOverlay = description ? true : false;
  const { isMobile } = useBreakpoints();

  return (
    <div
      className={cn(
        showActiveOverlay || isMobile ? "bg-tints-purple" : "bg-core-white",
        "border-core-black text-core-black rounded-sm border border-solid",
        "relative",
        "mb-2 h-full max-h-[320px] min-h-[320px] max-w-[350px] min-w-[250px] pb-[50%] lg:max-w-[400px] lg:min-w-[320px] lg:pb-0",
        "overflow-hidden transition-colors duration-500 ease-in-out hover:cursor-pointer",
      )}
      onMouseEnter={() => {
        setShowActiveOverlay(true);
      }}
      onMouseLeave={() => {
        setShowActiveOverlay(false);
      }}
    >
      <div className="w-4/5">
        <Typography.H6 className="text-core-black p-4">{title}</Typography.H6>
      </div>

      <CSSTransition
        in={(showOverlay && showActiveOverlay) || isMobile}
        timeout={1000}
        unmountOnExit
        classNames={{
          enter: "transition-translate duration-500 animate-slide-up",
          exit: "transition-translate duration-500 animate-slide-down",
          exitDone: "hidden",
        }}
      >
        <TextOverlay text={description || ""} />
      </CSSTransition>

      {showOverlay && !isMobile && (
        <Image
          width={32}
          height={32}
          src={
            showActiveOverlay
              ? "/static/icons/close-circle.png"
              : "/static/icons/open-circle.png"
          }
          alt={showActiveOverlay ? "close-circle" : "open-circle"}
          className={cn(
            showActiveOverlay
              ? "animate-rotate-90"
              : "animate-rotate-90-negative",
            "pointer-events-auto absolute right-2 bottom-2 cursor-pointer transition-transform duration-500 lg:pointer-events-none",
          )}
          onClick={() => {
            setShowActiveOverlay(!showActiveOverlay);
          }}
        />
      )}
    </div>
  );
};

export default CapabilityServiceCard;
